import type { CSSProperties } from "react";
import { DotMatrixLoader } from "../icon-bank/DotMatrixLoader";

interface InProgressSpinnerProps {
  size?: number;
  color?: string;
  label?: string;
  className?: string;
  style?: CSSProperties;
}

export function InProgressSpinner({
  size = 16,
  color = "var(--fintheon-accent)",
  label = "Loading",
  className,
  style,
}: InProgressSpinnerProps) {
  return (
    <DotMatrixLoader
      variant="loading"
      size={size}
      color={color}
      label={label}
      className={className}
      style={style}
    />
  );
}
